import { useMemo } from 'react';

import { PlatformExecuteAdHocQueryTeamParams } from '@cloudquery/api-platform';

import { useFetchAllParallelQueries } from '@/hooks/useFetchAllQueries';

import { XYChart } from './xyChart';
import { XYChartVariant, CardVariantProps } from '../../types';
import { CardWrapper } from '../cardWrapper';
import { XYChartLoader } from './xyChartLoader';
import { mapXYChartData } from '../../utils/mappers';

interface AdditionalProps {
  variantProps: XYChartVariant;
}

export const XYChartCard = ({
  clearFilters,
  description,
  query,
  sx,
  title,
  variantProps,
}: CardVariantProps & AdditionalProps) => {
  const queries = useMemo<
    { baseQuery: string; params: PlatformExecuteAdHocQueryTeamParams; title?: string }[]
  >(() => [query, ...(variantProps.queries || [])].filter(Boolean), [variantProps.queries, query]);
  const queryResults = useFetchAllParallelQueries(queries);

  return (
    <CardWrapper
      clearFilters={clearFilters}
      description={description}
      query={queries.map((query) => query.baseQuery).join(';\n')}
      queryResult={queryResults}
      renderContent={() => undefined}
      renderContentArray={(results) => {
        const mappedData = results.map((result, i) => {
          return {
            data: mapXYChartData(result.data),
            dataKey: queries[i].title || `Series${results.length > 1 ? ` ${i + 1}` : ''}`,
          };
        });

        return <XYChart data={mappedData} />;
      }}
      renderLoading={() => <XYChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
